import store from "@/store/index";

const actionsBtns = {
  namespaced: true,
  state: {
      btnPressed: '',
      startTime: '',
      duration: '',
      result: {}
  },
  mutations: {
    setButtonPressed(state, data) {
      // Used to update the active Value
      state.btnPressed = data;
    },
    setButtonEmpty(state){
      state.btnPressed = "";
    },
    setActiveValue(state, [name, data]) {
      // Used to update the active Value
      state.active[name] = data;
    },
    setResult(state, data){
      state.result = data;
    }
  },
  actions: {
    sendData: async ({commit}, payload) => {
      try{
        let sTime = payload[0];
        let dur = payload[1];
        store.commit("actionsBtns/setResult", [sTime, dur]);
      }catch (err) {
        // console.log(err);
      }
    }
  }
};

export default actionsBtns;
